@defer (when hasLoaded()) {
  <article>
    <app-page-title [canGoBack]="true" [label]="site()?.title" (click)="goBack()"></app-page-title>
    <app-site-plan-dashboard [site]="site()"></app-site-plan-dashboard>
  </article>
} @placeholder {
  <i class="mdi mdi-loading mdi-spin-x2"></i>
}
